/**
 * Environment configuration
 * Centralizes all environment variables
 */

export const config = {
  apiUrl: import.meta.env.VITE_API_URL,
  appIdUri: import.meta.env.VITE_APP_ID_URI,
  environment: import.meta.env.VITE_ENVIRONMENT,
  version: import.meta.env.VITE_VERSION,
  virtualDirectory: import.meta.env.VITE_VIRTUAL_DIRECTORY || '/',
  clientId: import.meta.env.VITE_CLIENT_ID,
  redirectUrl: import.meta.env.VITE_REDIRECT_URL,
};

export default config;

